import styled from "styled-components";

export const TextareaGroup = styled("div")(({ theme }) => ({
  width: "100%",
}));

export const Label = styled("label")(({ theme }) => ({
  display: "block",
  width: "100%",
  fontSize: 10,
  paddingLeft: 15,
  paddingTop: 2,
  color: theme.palette.input.labelText,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",

  [theme.down("sm")]: {
    fontSize: 9,
    paddingLeft: 12,
  },
}));

export const TextareaBlock = styled("div")(({ theme, isError }) => ({
  ...theme.mixins.flexColumn,
  borderRadius: 4,
  border: `1px solid ${isError ? theme.palette.input.borderError : theme.palette.input.border}`,
  ...(isError ? { backgroundColor: theme.palette.input.errorBg } : {}),
  transition: "all .2s ease",

  "&:focus-within": {
    borderColor: isError ? theme.palette.input.borderError : theme.palette.input.borderFocus,
    boxShadow: isError
      ? `0 0 0 3px ${theme.palette.input.errorShadow}`
      : `0 0 0 3px ${theme.palette.input.focusShadow}`,
  },
}));

export const TextareaElement = styled("textarea")(({ theme }) => ({
  ...theme.paddings(6, 15, 10, 15),
  width: "100%",
  minHeight: 96,
  border: "none",
  resize: "vertical",
  backgroundColor: "transparent",
  fontSize: 16,
  fontFamily: "inherit",
  lineHeight: 1.4,

  "&:hover, &:active, &:focus": {
    outline: "none",
  },

  [theme.down("sm")]: {
    fontSize: 14,
    ...theme.paddings(6, 12, 10, 12),
  },
}));

export const Error = styled("div")(({ theme }) => ({
  color: theme.palette.input.errorText,
  fontSize: 14,
  marginTop: 4,
  fontWeight: 500,

  [theme.down("sm")]: {
    fontSize: 13,
  },
}));
